import { Calculator, Heartbeat, TrendDown, TrendUp } from "@phosphor-icons/react";

export default function ClientHealthCard({ health }) {
    if (!health) return null;
    const cur = health.current_period || {};
    const d = health.delta || {};
    const headline = cur.median_proposal_to_first_payment_days;
    const headlineDelta = d.median_proposal_to_first_payment_days;
    const hasData = (cur.sample_count ?? 0) > 0 || (cur.proposals_in_window ?? 0) > 0;
    const trendCls =
        headlineDelta == null ? "text-slate-400" :
            headlineDelta < 0 ? "text-emerald-600" :
                headlineDelta > 0 ? "text-rose-600" : "text-slate-400";
    const TrendIcon = headlineDelta == null ? Calculator : headlineDelta < 0 ? TrendDown : headlineDelta > 0 ? TrendUp : Calculator;

    return (
        <div className="reedos-card p-4" data-testid="client-health-card">
            <div className="reedos-eyebrow flex items-center gap-1.5"><Heartbeat size={11} weight="fill" /> Lifecycle health · {health.window_days}d</div>
            {!hasData ? (
                <div className="text-xs text-slate-500 mt-2 py-2">Not enough data yet.</div>
            ) : (
                <>
                    <div className="flex items-baseline gap-2 mt-1">
                        <span className="font-display text-2xl font-bold reedos-data text-slate-900 leading-none">
                            {headline == null ? "—" : `${headline}d`}
                        </span>
                        <span className={`inline-flex items-center gap-0.5 text-[10px] font-semibold ${trendCls}`}>
                            <TrendIcon size={10} weight="bold" />
                            {headlineDelta == null ? "no prior" : headlineDelta === 0 ? "no change" : `${Math.abs(headlineDelta).toFixed(1)}d ${headlineDelta < 0 ? "faster" : "slower"}`}
                        </span>
                    </div>
                    <div className="text-[11px] text-slate-500 mt-0.5">Proposal → first payment median</div>
                    <div className="mt-3 space-y-1 text-[11px]">
                        <Stage label="Proposal → PO" value={cur.median_proposal_to_po_days} />
                        <Stage label="PO → Invoice" value={cur.median_po_to_first_invoice_days} />
                        <Stage label="Invoice → Payment" value={cur.median_invoice_to_first_payment_days} />
                    </div>
                </>
            )}
        </div>
    );
}

function Stage({ label, value }) {
    return (
        <div className="flex items-center justify-between">
            <span className="text-slate-500">{label}</span>
            <span className="reedos-data font-semibold text-slate-900">{value == null ? "—" : `${value}d`}</span>
        </div>
    );
}
